import { render } from "./CrmPage.vue?vue&type=template&id=3ae46676&scoped=true"
import script from "./CrmPage.vue?vue&type=script&lang=js"
export * from "./CrmPage.vue?vue&type=script&lang=js"

import "./CrmPage.vue?vue&type=style&index=0&id=3ae46676&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae46676"]])

export default __exports__